import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { isNumericField } from "../../../utils/isNumericField.ts";
import SwitchMenuItem from "./SwitchMenuItem";

interface Props {
  field: ReportField;
  saveChanges: (changes: Partial<FieldConfiguration>, causeClosing: boolean) => void;
  readonly: boolean;
}

export default function BlankZeroMenuItem({ field, saveChanges, readonly }: Props) {
  if (!isNumericField(field)) {
    return null;
  }

  return (
    <SwitchMenuItem
      caption="Blank Zero"
      value={!!field.config.blankZero}
      onClick={() => saveChanges({ blankZero: !field.config.blankZero }, false)}
      disabled={readonly}
    />
  );
}
